import { ImageLocation } from '@examdojo/question';
import { TableInsertModel, TableRowModel } from '@examdojo/supabase';

export type ReviewSolutionImageHttpModel = Pick<
  TableRowModel<'user_images', 'review'>,
  | 'current_review_session'
  | 'action_id'
  | 'bucket_name'
  | 'created_at'
  | 'id'
  | 'image_name'
  | 'order'
  | 'updated_at'
  | 'user_id'
>;

export type ReviewSolutionImageCreateModel = Pick<
  TableInsertModel<'user_images', 'review'>,
  | 'bucket_name'
  | 'image_name'
  | 'order'
  | 'current_review_session'
  | 'action_id'

  // TODO - should it be here?
  | 'user_id'
>;

export type ReviewSolutionImageStoreModel = ReviewSolutionImageHttpModel & {
  url?: string | null;
  location: ImageLocation;
};
export type ReviewSolutionImageUIModel = ReviewSolutionImageStoreModel;

export const REVIEW_SOLUTION_IMAGE_BUCKET_NAME = 'reviewer_solutions';

export const SolutionCaptureQueryParam = 'capture';
